import { SupportedGames } from "@repo/game-configuration"

/**
 * Games that support sealed product imports
 * This list should match the configuration in game-importer's SEALED_PRODUCT_CONFIGS
 */
const GAMES_WITH_SEALED_PRODUCT_SUPPORT = new Set<SupportedGames>([
	SupportedGames.FAB,
	SupportedGames.Lorcana,
	SupportedGames.MTG,
	SupportedGames.OnePiece,
	SupportedGames.Sorcery,
	SupportedGames.Pokemon,
	SupportedGames.Riftbound,
	SupportedGames.Rise,
	SupportedGames.Drakerion,
	SupportedGames.Cyberpunk,
	SupportedGames.StarWarsUnlimited,
	SupportedGames.PokemonJapan,
	SupportedGames.NarutoMythos,
	SupportedGames.GrandArchive,
	SupportedGames.Eoa,
	SupportedGames.DbsFusion,
	SupportedGames.DbsMasters,
	SupportedGames.Gundam,
	SupportedGames.ChronoCore,
	SupportedGames.Palworld,
	SupportedGames.Azuki,
	SupportedGames.Dreamland,
	SupportedGames.YuGiOh,
	SupportedGames.YuGiOhOcg,
])

/**
 * Check if a game supports sealed product imports
 *
 * @param gameSlug - The game slug to check
 * @returns true if the game has sealed products support configured
 *
 * @example
 * ```typescript
 * if (gameHasSealedProductSupport(SupportedGames.FAB)) {
 *   // Show import sealed products button
 * }
 * ```
 */
export function gameHasSealedProductSupport(gameSlug: SupportedGames): boolean {
	return GAMES_WITH_SEALED_PRODUCT_SUPPORT.has(gameSlug)
}
